import { welcomeKitMetafieldsUpdateKeys } from 'api/shopify/welcomeKitMetafieldsUpdate/welcomeKitMetafieldsUpdate.schemas';
import { z } from 'zod';

export const WELCOME_KIT_METAFIELDS_NAMESPACE = 'custom';
export const DESCRIPTORS_METAFIELDS_NAMESPACE = 'descriptors';
export const NOTIFICATIONS_METAFIELDS_NAMESPACE = 'notifications';

export const WELCOME_KIT_METAFIELDS_KEYS = {
  [welcomeKitMetafieldsUpdateKeys.enum.welcomeKit]: 'received_welcome_kit',
  [welcomeKitMetafieldsUpdateKeys.enum.otpTp]: 'received_otp_tp_welcome_box'
};
export const NOTIFICATION_METAFIELD_KEYS = {
  V53_DISMISSED: 'v53-dismissed',
  AGZ_QUICK_BUY_DISMISSED: 'agz-quick-buy-dismissed',
  APAC_CURRENCY_MIGRATION_DISMISSED: 'apac-currency-migration-dismissed'
} as const;

export const SHAKER_METAFIELD_KEY = 'received_ag1_shaker_upgrade_gift';

export const LAST_SUCCESSFUL_LOGIN_METAFIELD_KEY = 'last-successful-login';
export const FAILED_LOGIN_ATTEMPTS_METAFIELD_KEY = 'failed-login-attempts';
export const MAX_INACTIVE_PERIOD = 90 * 24 * 60 * 60 * 1000; // 90 days
export const MAX_FAILED_LOGIN_ATTEMPTS = 5;
export const FAILED_LOGIN_TIME_WINDOW = 10 * 60 * 1000; // 10 minutes
export const LOCKED_ACCOUNT_TIMEOUT = 500 * 1000; // 500 seconds

export const CUSTOMER_STATE = z.enum(['ACTIVE', 'INACTIVE', 'NOT_FOUND', 'LOCKED', 'SUSPENDED']);

export const httpMethods = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  PATCH: 'PATCH',
  DELETE: 'DELETE'
} as const;

export const dataDogStatus = {
  ERROR: 'error',
  INFO: 'info',
  WARN: 'warn'
} as const;

export const authEventType = {
  ATTEMPT: 'attempt',
  SUCCESS: 'success',
  FAIL: 'fail'
} as const;
